/*
 * @Author: liyxt
 * @Date: 2020-05-19 15:47:39
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-28 15:08:58
 * @Description: file content
 */ 
import React, { Component } from 'react';
import OriginSlider from 'bee-slider';
require('bee-slider/build/Slider.css');

class Slider extends Component {
    render() {
		return <OriginSlider {...this.props} />;
	}
}

Slider.createSliderWithTooltip = OriginSlider.createSliderWithTooltip;

export default Slider;